import { isEmpty } from "lodash";
import "./resource";
import { thor } from "../../typings/thor";

class QuotasService {
    public static $inject: string[] = ["$log", "$q", "quotasResource"];

    public currentYear = new Date().getFullYear();

    private quotas = {} as thor.Quotas;

    constructor(private $log: ng.ILogService, private $q: ng.IQService, private quotasResource) {}

    public get(organizationId) {
        return this.quotasResource()
            .get({ id: organizationId })
            .$promise.then(result => {
                this.quotas = angular.copy(result);
                return this.$q.resolve();
            })
            .catch(error => {
                this.$log.error("Error while getting organization quotas", error);
                return this.$q.reject(error);
            });
    }

    public getYearQuota(sale: thor.SaleGet) {
        const saleYear = new Date(sale.datetime).getFullYear();

        if (isEmpty(this.quotas)) {
            return;
        }

        return saleYear === this.currentYear
            ? this.quotas[thor.YearQuota.Current]
            : saleYear === this.currentYear + 1
            ? this.quotas[thor.YearQuota.Next]
            : undefined;
    }

    public putCurrentYearQuota({ organizationId: id, count }) {
        return this.put({ id, count, yearType: "current-year" });
    }

    public putNextYearQuota({ organizationId: id, count }) {
        return this.put({ id, count, yearType: "next-year" });
    }

    private put({ id, count, yearType }: any) {
        const data = { organization_id: id, count };
        return this.quotasResource()
            .put({ yearType }, data)
            .$promise.catch(error => {
                this.$log.error(`Error while updating organization ${id} quotas ${yearType} ${count}`, error);
                return this.$q.reject(error);
            });
    }
}

angular.module("thor.core.quotas.service", ["thor.core.quotas.resource"]).service("quotasService", QuotasService);
